<template>
  <div>
    <div class="record1"></div>
    <div class="record2">
      <el-form ref="added" inline size="medium">
        <el-form-item label="标题">
          <el-input @keyup.enter.native="search" v-model="query.title" placeholder="请输入标题"
            clearable show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="query.type" placeholder="请选择分类" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="社工服务" value="community"></el-option>
            <el-option label="志愿风采" value="volunteer"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="请选择状态" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="已发布" :value="10"></el-option>
            <el-option label="已下线" :value="20"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item v-if="JudgeButton(role_permission,'news/query')">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'news/query')">
          <el-button type="info" icon="el-icon-refresh-left" @click="query.title= '';query.type = '';query.status='';search()">重置</el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'news/increase')">
          <el-button type="success" icon="el-icon-circle-plus" @click="$refs.newsAddOrEdit.show('')"> 新增 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="record3">
      <el-table v-loading='loading' stripe border :data="list" tooltip-effect="dark" style="width: 98%">
        <el-table-column align='center' prop="title" label="资讯标题">
          <template slot-scope="scope">
            <div class="flex-box" style="justify-content: center;">
              <el-image v-if="scope.row.thumb" @click="imgUrl=scope.row.thumb;dialogVisible=true"
                style="width: 15px; height: 15px;margin-right: 5px;position: relative;top: 3px;cursor: pointer;"
                :src="scope.row.thumb + '?imageMogr2/thumbnail/100x'"
                fit="cover"></el-image>
                <span class="text-elps" style="max-width: calc(100% - 20px);">{{ scope.row.title }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column align='center' label="分类" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 'community'">社工服务</span>
            <span v-if="scope.row.type == 'volunteer'">志愿风采</span>
          </template>
        </el-table-column>
        <el-table-column align='center' prop="created_user" label="发布人" width="170">
        </el-table-column>

        <el-table-column align='center' prop="created_at" label="发布时间" width="170">
        </el-table-column>

        <el-table-column align='center' prop="sort" label="排序" width="100">
        </el-table-column>

        <el-table-column align='center' label="状态" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 10" style="color: #05d705;">已发布</span>
            <span v-if="scope.row.status == 20">已下线</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align='center' width="380">
          <template slot-scope="scope">
            <el-button size="mini" type="primary"
              @click="$refs.detail.show(scope.row)">浏览</el-button>
            <el-button v-if="JudgeButton(role_permission,'news/edit')" size="mini" type="primary"
               @click="$refs.newsAddOrEdit.show(scope.row)">编辑</el-button>
            
            <el-button v-if="JudgeButton(role_permission,'news/edit') && scope.row.status == 20" size="mini" type="success"
              @click="handleChangeStatus(scope.row, 10)">设为已发布</el-button>
            <el-button v-if="JudgeButton(role_permission,'news/edit') && scope.row.status == 10" size="mini" type="warning"
              @click="handleChangeStatus(scope.row, 20)">设为已下线</el-button>
            <el-button v-if="JudgeButton(role_permission,'news/delete')" size="mini"
               type="danger" @click="handleDelete(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="query.total">
      </el-pagination>
    </div>
    <newAddOrEditDialog ref='newsAddOrEdit' @success='getList()'></newAddOrEditDialog>
    <detailDialog ref='detail'></detailDialog>
    <el-dialog
      title="查看图片"
      :visible.sync="dialogVisible"
      width="40%"
      center
      >
      <img :src="imgUrl" alt="" style="display: block;width: 100%;">
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import userInfoAPI from '@/api/api';
  import newAddOrEditDialog from './components/newAddOrEditDialog.vue';
  import detailDialog from './components/detailDialog.vue';
  var that;
  export default {
    components: {
      newAddOrEditDialog,
      detailDialog
    },
    props: {},
    data() {
      return {
        loading: true,
        query: {
          page_limit: 10,
          page: 1,
          title: '',
          type: '',
          status: '',
          total: 0
        },
        list: [],
        dialogVisible: false,
        imgUrl: '',
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    watch: {},
    created() {
      that = this;
      if (this.$store.state.cache.cacheNewsQuery) this.query = this.$store.state.cache.cacheNewsQuery
      this.getList()
    },
    beforeDestroy() {
      this.$store.commit('CACHE_NEWS', this.query)
    },
    methods: {
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      search() {
        this.loading = true;
        this.query.page = 1;
        this.list = [];
        this.getList()
      },
      handleDelete(row) { //删除
        this.$confirm('此操作将永久删除该记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.delInformation(row.id).then(res => {
            if (res.data.code == 0) {
              this.$message.success(res.data.msg)
              this.getList()
            }else{
              this.$message.error(res.data.msg)
            }
          })
        })
      },
      handleChangeStatus(row, status){
        let row1 = JSON.parse(JSON.stringify(row))
        row1.status = status
        this.$confirm("是否确定将该资讯"+(status == 20?'设为已下线':'设为已发布')+"状态？", '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delete row1.type_description
          delete row1.created_at
          delete row1.created_user
          delete row1.read_num
          delete row1.status_description
          console.log(row1)
          userInfoAPI.updateInformation(row1).then(res => {
            if (res.data.code == 0) {
              row.status = status
              this.$message.success(res.data.msg)
              this.getList()
            }else{
              this.$message.error(res.data.msg)
            }
          })
        })
      },
      getList() {
        this.loading = true
        userInfoAPI.getInformationList(this.query).then(res => {
          if (res && res.data.code == 0) {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.getList();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .record1 {
    height: 20px;
  }

  .record3 {
    margin-left: 20px;
  }
  .record2 .el-form-item {
    margin-left: 20px;
  }
</style>
